import { takeLatest } from 'redux-saga/effects';
import {
  INIT_GF_CAMPAIGN,
  runGfCampaignCheck,
  runSpaEvent,
  SEND_SPA_EVENT,
} from './actions';

export const dySagas = [
  takeLatest(INIT_GF_CAMPAIGN.request, runGfCampaignCheck),
  takeLatest(SEND_SPA_EVENT, () => runSpaEvent(false)),
];
